export class InvalidRefreshTokenException extends Error {
  constructor() {
    super("invalid refresh token");
  }
}
